document.addEventListener("DOMContentLoaded", function () {
  function updateKlarnaPrice() {
    var priceElement = document.querySelector(".price-item--regular"); // Selettore prezzo
    var klarnaRateElement = document.getElementById("klarna-rate");

    if (priceElement && klarnaRateElement) {
      var priceText = priceElement.textContent.replace(/[^\d,\.]/g, "").replace(",", "."); // Pulisce il prezzo
      var price = parseFloat(priceText);

      if (!isNaN(price)) {
        var installment = (price / 3).toFixed(2); // Divide in 3 rate e formatta
        klarnaRateElement.textContent = installment + " €"; // Aggiorna il testo
      }
    }
  }

  // Rileva cambio variante su Shopify
  document.addEventListener("change", function (event) {
    if (event.target.matches("[name='id']")) {
      setTimeout(updateKlarnaPrice, 500); // Ritardo per attendere il caricamento
    }
  });

  updateKlarnaPrice(); // Aggiorna inizialmente
});